import React from 'react';
import { View, Image, TouchableWithoutFeedback } from 'react-native';

import PropTypes from 'prop-types';

import { Images } from '../../../Themes';

import styles from './CloseButton.Styles';

function CloseButton({ icon, onPress, testID, ...props }) {
  return (
    <TouchableWithoutFeedback onPress={onPress} {...props} testID={testID}>
      <View style={styles.closeButtonContainerStyle}>
        <Image source={icon} />
      </View>
    </TouchableWithoutFeedback>
  );
}

CloseButton.defaultProps = {
  icon: Images.ic_close,
};

CloseButton.propTypes = {
  icon: PropTypes.shape({ uri: PropTypes.string }),
  onPress: PropTypes.func.isRequired,
  testID: PropTypes.string,
};

export default CloseButton;
